import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IKeyArray } from 'types/IKeyArray';
import { selectSessionMode } from 'core/selectors/admin/sessionMode';
import { selectActionRegister } from './actionRegister';
import { ICopyItem } from 'core/slices/commands';
import { IActionRegister } from 'core/slices/register';
import { Mode } from 'core/slices/session';

const mode = selectSessionMode;
const register = (state, actionId?) => selectActionRegister(state, actionId);
const selected = (state: RootState) => state.commands.selected;
const id = (state: RootState, actionId, id?: number) => id;
const actionEntityId = (state: RootState) => state.state[EntityTypes.ACTION_ENTITY];

export const selectActionEntitySelected = createSelector(
  [mode, register, id, actionEntityId],
  (mode: Mode, register: IActionRegister, id: number, actionEntityId: number) => {
    return mode === Mode.ADMIN
      ? actionEntityId === id //|| (selected && !!selected[id])
      : register && register.entities[id]
      ? register.entities[id].selected
      : false;
  },
);
